import { isNull } from 'utils/tsHelpers';
import { isObject } from 'utils/helpers';
import { useOnConditionValueReset } from './useOnConditionValueReset';
import { useOnConditionValuesReset } from './useOnConditionValuesReset';
import {
  AnyComparator,
  DateComparator,
  DefaultComparator,
  FieldType,
  IsWithinComparator,
  IsOneOfComparator,
  IterableDistanceUnit,
} from '../../../../types';
import { useConditionStateContext, useQueryStateContext } from '../../../../contexts';
import { useConditionState } from '../../../../hooks/condition';

export const useOnComparatorChange = (onChange: (comparator: AnyComparator) => void) => {
  const onConditionValuesReset = useOnConditionValuesReset();
  const onConditionValueReset = useOnConditionValueReset();
  const { setToLatestId } = useQueryStateContext();
  const { condition, setCondition } = useConditionState();
  const { value, setValue, fieldType } = useConditionStateContext();

  return (selectedComparator: AnyComparator | null) => {
    if (isNull(selectedComparator)) return; // selectedComparator shouldn't be null and this is only to satisfy TS

    setToLatestId(condition.id);
    if (selectedComparator === IsOneOfComparator.IS_ONE_OF) {
      onConditionValuesReset();
      onChange(DefaultComparator.EQUALS);
    } else if (selectedComparator === IsOneOfComparator.IS_NOT_ONE_OF) {
      onConditionValuesReset();
      onChange(DefaultComparator.DOES_NOT_EQUAL);
    } else if (
      selectedComparator === DefaultComparator.IS_SET ||
      selectedComparator === DefaultComparator.IS_NOT_SET ||
      (selectedComparator !== DateComparator.BETWEEN && isObject(value))
    ) {
      onConditionValueReset();
      // Need to set value and comparator simultneously for undo stack
      setCondition((currentCondition) => ({
        ...currentCondition,
        value: '',
        comparatorType: selectedComparator,
      }));
    } else if (
      fieldType === FieldType.GEO_LOCATION &&
      selectedComparator === IsWithinComparator.IS_WITHIN
    ) {
      onConditionValueReset();
      setValue({
        location: { lat: 0, lon: 0 },
        distance: { distance: 1, unit: IterableDistanceUnit.miles },
      }); // set the value to default geoLocation
      onChange(selectedComparator);
    } else {
      onConditionValueReset();
      onChange(selectedComparator);
    }
  };
};
